import React, { useState } from 'react';
import 'src/pages/components.scss';
import { useHistory } from "react-router-dom";
import AuthService from 'src/services/auth.service';
import './login.scss';
import 'src/helper.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios, { AxiosResponse, AxiosError } from "axios";

const LoginContainer = () => {

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [loadingMsg, setLoadingMsg] = useState<{ [key: string]: any }>({ message: "", loading: false });
    const [emailError, setEmailError] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");
    const history = useHistory();
    const token = localStorage.getItem("user")?.replace(/^"(.*)"$/, '$1');


    const validateEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        let email = e.target.value;
        let emailCheck = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
        if (!emailCheck.test(email)) {
            setEmailError('Enter valid email');
        } else {
            setEmailError("");
        }
    }

    const validatePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        let password = e.target.value;
        let passwordCheck = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;

        if (!passwordCheck.test(password)) {
            setPasswordError('Enter valid password');
        } else {
            setPasswordError("");
        }
    }

    const handleLogin = () => {
        if (emailError) {
            toast.error(emailError, {
                 position: 'top-center'
            });
        }
        else {
            setLoadingMsg({ message: "", loading: true });
            AuthService.login(username, password).then((resp) => {
                console.log(resp);
                axios.get(`${global.api_url}/index.php/api/v1/roles/features`, {
                    headers: {
                        'Authorization': `${resp}`
                    }
                })
                    .then((response: AxiosResponse) => {
                        localStorage.setItem("rbac", JSON.stringify(response.data.message));
                        const features = response.data.message;
                    const hasAdminPlatform = features.some((feature: any) => feature.feature_name === 'ADMIN_PLATFORM');
                    const hasAdminCompany = features.some((feature: any) => feature.feature_name === 'ADMIN_COMPANY');
                    if (hasAdminPlatform) {
                        history.push("/add_view_company");
                        window.location.reload();
                    } else {
                        history.push("/dashboard");
                        window.location.reload();
                    } 
                    })
                    .catch((error: AxiosError) => {
                        toast.error(error.message + (error.response?.statusText ? ': ' + error.response?.statusText : "") || 'Something went wrong, please try again.');
                    });
            },
                error => {
                    const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    setLoadingMsg({ message: resMessage, loading: false });
                    toast.error(resMessage, {
                        position: 'top-center'
                    });
                }
            )
        }
    }

    const updateField = (e: any) => {
        let el = e.currentTarget;
        el.name === "username" ? setUsername(el.value) : setPassword(el.value);
    }

    return (

        <div className="container">
            <h3 className="text-center margin-top-20"><img src="Shipdesk.png" alt="shipdesk_logo" style={{ width: '15rem' }} /></h3>
            <form>
                <div className="row align-textbox margin-bottom-20 form-group">
                    <label htmlFor="email" style={{color:'black'}}>Email Address</label><br />
                    <input type="email" name="username" className="form-control" placeholder="Enter your email address" value={username} onChange={(e) => { updateField(e); validateEmail(e) }} />
                </div>
                <div className="row align-textbox margin-bottom-20 form-group">
                    <label htmlFor="password" className="col-7"style={{color:'black'}}>Password</label><br />
                    <a href="#/forgotPassword" className="col-5 textbox-md">Forgot Password?</a>
                    <input type="password" name="password" className="form-control" value={password} onChange={(e) => { updateField(e) }} />
                </div>
                <div className="row align-textbox margin-top-10 margin-bottom-20 form-group">
                    <button type="submit" className="btn btn-primary btn-block" disabled={loadingMsg.loading || username === '' || password === ''} title="Please" onClick={() => handleLogin()}>
                        {loadingMsg.message && loadingMsg.loading &&
                            <span className="spinner-border spinner-border-sm"></span>
                        }
                        <span>Login</span>
                    </button>
                </div>
            </form>
            <div className="row align-textbox margin-top-10 margin-bottom-20">
                <button className="btn btn-outline-primary col-12">
                    <img src="google-icon.svg" className="float-left" alt="google-icon" width={"6.75%"} style={{ padding: "1px" }}></img>SIGN IN WITH GOOGLE
                </button>
            </div>
            <div className="disclaimer align-textbox" style ={{color : 'black'}}>
                <i><a className="textbox-md" href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
                    <a className="textbox-md" href="https://policies.google.com/terms">Terms of Service</a> apply.<br /></i>
            </div>
        </div>
    );
}

export default LoginContainer;
